import { h } from 'preact';
export const CloseIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.9497 8.46446L15.5355 7.05024L11.9993 10.5865L8.46376 7.05095L7.04955 8.46516L10.5851 12.0007L7.05025 15.5355L8.46447 16.9497L11.9993 13.4149L15.5348 16.9504L16.949 15.5362L13.4135 12.0007L16.9497 8.46446Z" fill="#4A5D85" />
</svg>
  )
}
